module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }